// Style toggle for lifestyle images with pattern position support
// Pattern positions (1, 8, 18, 21, 28, 38, 41, 48, 58...) ALWAYS show lifestyle images
// Toggle OFF: Only pattern positions show lifestyle images
// Toggle ON: ALL positions show lifestyle images

document.addEventListener('DOMContentLoaded', function() {
  const styleToggleBtn = document.querySelector('.style-toggle-btn');

  if (styleToggleBtn) {
    styleToggleBtn.addEventListener('click', function() {
      // Find both span elements within the button
      const productView = this.querySelector('.product-view');
      const lifestyleView = this.querySelector('.lifestyle-view');

      // Toggle the hidden class on both spans
      productView.classList.toggle('hidden');
      lifestyleView.classList.toggle('hidden');

      // Find all lifestyle image containers
      const lifestyleImages = document.querySelectorAll('.product-link .product-item__bg__under.product-lifestyle-image.no_opac');

      lifestyleImages.forEach(image => {
        // Check if this is a pattern position (should always be active)
        const isPatternPosition = image.hasAttribute('data-pattern-active');

        // If lifestyle view is visible (doesn't have hidden class), add active class to ALL images
        if (!lifestyleView.classList.contains('hidden')) {
          image.classList.add('active');
        } else {
          // Toggle is OFF - only pattern positions should have active class
          if (isPatternPosition) {
            // Keep pattern positions active
            image.classList.add('active');
          } else {
            // Remove active class from non-pattern positions
            image.classList.remove('active');
          }
        }
      });
    });
  }

  // Initialize pattern positions on page load (ensure they're active)
  initializePatternPositions();
});

// Check if a position is a lifestyle pattern position
// Positions: 1, 8, 18, 21, 28, 38, 41, 48, 58...
// Pattern from position 8: cycle of +10, +3, +7 repeating (cycle length = 20)
function isLifestylePatternPosition(position) {
  position = parseInt(position, 10);
  if (isNaN(position)) return false;

  if (position === 1 || position === 8) return true;

  if (position > 8) {
    const offsetFrom8 = position - 8;
    const positionInCycle = offsetFrom8 % 20;
    // Cycle positions: 0 (at 8, 28, 48...), 10 (18, 38, 58...), 13 (21, 41, 61...)
    if (positionInCycle === 0 || positionInCycle === 10 || positionInCycle === 13) {
      return true;
    }
  }

  return false;
}

// Check if a position is a video pattern position
// Positions: 11, 31, 51, 71... (every 20 starting at 11)
function isVideoPatternPosition(position) {
  position = parseInt(position, 10);
  if (isNaN(position)) return false;

  if (position >= 11) {
    const videoOffset = position - 11;
    return videoOffset % 20 === 0;
  }

  return false;
}

// Function to initialize pattern positions (useful for dynamically loaded content)
function initializePatternPositions() {
  // First, handle server-rendered pattern positions
  const patternPositionImages = document.querySelectorAll('.product-item__bg__under[data-pattern-active="true"]');
  patternPositionImages.forEach(image => {
    image.classList.add('active');
    image.classList.add('pattern-position');
  });

  // Also check products by their data-position attribute (for dynamically loaded content)
  const productItems = document.querySelectorAll('[data-product-grid-item][data-position]');
  productItems.forEach(item => {
    const position = item.getAttribute('data-position');

    // Handle lifestyle images
    if (isLifestylePatternPosition(position)) {
      const lifestyleImg = item.querySelector('.product-item__bg__under.product-lifestyle-image');
      if (lifestyleImg && !lifestyleImg.hasAttribute('data-pattern-active')) {
        lifestyleImg.setAttribute('data-pattern-active', 'true');
        lifestyleImg.classList.add('active');
        lifestyleImg.classList.add('pattern-position');
        item.setAttribute('data-lifestyle-pattern-position', 'true');
      }
    }

    // Mark video positions
    if (isVideoPatternPosition(position)) {
      item.setAttribute('data-video-pattern-position', 'true');
    }
  });
}

// Re-initialize when products are dynamically loaded (for infinite scroll, AJAX, etc.)
// This observer watches for new products being added to the grid
const observeProductGrid = () => {
  const productGrid = document.querySelector('#CollectionLoop, .product-grid');
  if (!productGrid) return;

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        // Small delay to ensure DOM is fully updated
        setTimeout(() => {
          initializePatternPositions();
          applyCurrentToggleState();
        }, 100);
      }
    });
  });

  observer.observe(productGrid, { childList: true, subtree: true });
};

// Apply the current toggle state to newly loaded products
function applyCurrentToggleState() {
  const styleToggleBtn = document.querySelector('.style-toggle-btn');
  if (!styleToggleBtn) return;

  const lifestyleView = styleToggleBtn.querySelector('.lifestyle-view');
  const isToggleOn = lifestyleView && !lifestyleView.classList.contains('hidden');

  const lifestyleImages = document.querySelectorAll('.product-link .product-item__bg__under.product-lifestyle-image.no_opac');

  lifestyleImages.forEach(image => {
    const isPatternPosition = image.hasAttribute('data-pattern-active');

    if (isToggleOn) {
      // Toggle is ON - all positions should be active
      image.classList.add('active');
    } else {
      // Toggle is OFF - only pattern positions should be active
      if (isPatternPosition) {
        image.classList.add('active');
      } else {
        image.classList.remove('active');
      }
    }
  });
}

// Start observing when DOM is ready
document.addEventListener('DOMContentLoaded', observeProductGrid);
